<template>
   <div>
      <div class="innerContainer block" style="padding: 10px 0;">
          <InfoUser @changeActiveCard='data=> emitToParent("changeActiveCard",this,data)' @userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
        <h1>{{ t('EXCLUSAO_CONTA') }}</h1>
        <div v-if="page == 'entrada'" class="area">
            <h2>{{ t('MOTIVO_EXCLUIR') }}</h2>
            <ul>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Não ando mais de metrô"/>
                        <div class="styled-radio"></div>
                        <span>{{ t('MOTIVO_NAO_USO') }}</span>
                    </label>
                </li>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Tive um problema com o serviço"/>
                        <div class="styled-radio"></div>
                        <span>{{ t('MOTIVO_PROBLEMA') }}</span>
                    </label>
                </li>
                <li>
                    <label class="div-radio">
                        <input type='radio' v-model="model.motivoPrincipal" value="Outros"/>
                        <div class="styled-radio"></div>
                        <span>{{ t('MOTIVO_OUTROS') }}</span>
                    </label>
                </li>
            </ul>
            <textarea v-model="model.explicacao" :placeholder="t('CONTE_MAIS_SAIDA')"></textarea>
            <ul class="errors" v-if="errors.length">
                <li v-for="(error, key) in errors" :key="key">{{error}}</li>
            </ul>
            <a class="btn block"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="enviar" @click="validTo('confirmacao', () => page = 'confirmacao')" >{{ t('ENVIAR') }}</a>
        </div>
        <div v-if="page == 'confirmacao'" class="area">
            <h2 class="red" style="text-align: center">{{ t('TEM_CERTEZA_EXCLUIR') }}</h2>
            <p>{{ t('TEM_CERTEZA_EXCLUIR_TEXTO_1') }}</p>
            <p>{{ t('TEM_CERTEZA_EXCLUIR_TEXTO_2') }}</p>

            <a class="btn block red"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="excluir conta" @click="deletar()" >{{ t('EXCLUIR_CONTA') }}</a>
            <p v-if="this.message" style="color: red; font-size: 14px; text-align: center;">{{ this.message }}</p>
            <p>{{ t('OU') }}</p>
            <a class="btn block"  appEvent="true" appEventCategory="excluir-conta" appEventLabel="continuar recarregando aqui" @click="returnToHome()" >{{ t('CONTINUAR_RECARREGANDO') }}</a>
            <modal-generico :infos="modalDeletado" :show="modalDeletadoShow" />
        </div>
      </div>
  </div>
</template>
<style lang="scss">

    .innerContainer > div.area {
        max-width: 860px;
        margin: 0 auto;
        p {
            margin: 15px 0;
            text-align: center;          
            color: #757476;  
            font-size: 20px;
        }
        h2.red { color: #ee3639; }
        .btn.red { background: #ee3639; }
        h2 {
            margin: 40px 0;
            text-align: center;
        }
        ul {
            list-style: none;
            margin: 0;
            color: #757476;
        }
        textarea {
            width: 100%;
            height: 150px;
            resize: none;
            border: 1px solid #757476;
            margin: 40px 0;
            padding: 20px;
            &::placeholder {
                height: 108px;
                text-align: center;
                padding: 40px;
                box-sizing: border-box;
            }
        }
        .btn {
            width: 50%;
            margin: 40px auto;
            height: 80px;
            line-height: 40px;
        }
        .errors {
            font-size: 14px;
            color: red;
        }
    }
</style>

<script>
import { translate } from '../services/translate.service';
    import { excluirConta } from '../services/user.service';
    import InfoUser from '../components/InfoUser.vue';
    import ModalGenerico from '../components/ModalGenerico.vue';
    import { resolvePromise, redirect, emitToParent, removeToken } from '../helpers/helpers'
    export default {
        name: 'excluirConta',
        data() {
            return {
                errors: [],
                page: 'entrada',
                modalDeletado: null,
                modalDeletadoShow: false,
                message:null,
                model: {
                    motivoPrincipal: null,
                    explicacao: null
                }
            }
        },
        components: {
            InfoUser,
            ModalGenerico
        },
        props:{
            userData:{
                type:Object
            },
        },
        methods:{
            t:translate,
            returnToHome() {
                this.$router.push('home');
            },
            validTo(para, successCb) {
                this.errors = [];
                if(para == 'confirmacao') {
                    if(this.model.motivoPrincipal) {
                        successCb();
                    } else {
                        this.errors.push(translate('VALIDATIONS.MOTIVO_REQUIRED'));
                    }
                }
                return false;
            },
            emitToParent,
            deletar(){
                this.message = null;
                if(this.userData.id){
                    let fd = new FormData();
                    fd.append('id', this.userData.id);
                    fd.append('name', this.userData.name);
                    fd.append('lastName', this.userData.lastName);
                    fd.append('phone', this.userData.phone);
                    fd.append('reasondelete', this.model.motivoPrincipal);
                    fd.append('reasonextendeddelete', this.model.explicacao);
                    
                    resolvePromise(excluirConta(fd),
                        ({ data }) => {
                            removeToken();
                            this.modalDeletado = { 
                                title: translate('CONTA_EXCLUIDA'),
                                text: translate('CONTA_EXCLUIDA_MSG'),
                                btn: 'ok',
                                eventLabel: 'Sua conta foi excluída',
                                onClose: () => {
                                    this.$router.push('home');
                                },
                            }
                            this.modalDeletadoShow = true;
                        },
                        (err) => {
                            this.message = translate('CONTA_EXCLUIDA_ERRO');
                        });
                }
            }
        },
        
        created(){
            console.log(this.userData);
            if(!sessionStorage.getItem("giro-token")) redirect("login",this)
        }
    }
</script>
